<template>
  <div>
    <h2>Quantidade de estabelecimentos: {{ quantidadeEstabelecimentos }}</h2>
    <h2>Quantidade de estabelecimentos com pedidos: {{ quantidadeEstabelecimentosComPedido }}</h2>
    <h2>Quantidade de pedidos: {{ quantidadePedidos }}</h2>
    <h2>Valor bruto: R$ {{ formatValor(valorBruto) }}</h2>
    <h2>Taxa de entrega dos pedidos: R$ {{ formatValor(taxaEntregaPedidos) }}</h2>
    <h2>Valor líquido: R$ {{ formatValor(valorLiquido) }}</h2>
    <h2>Ticket médio: R$ {{ formatValor(ticketMedio) }}</h2>
    <h2>Média de pedidos por estabelecimento: {{ mediaPedidosPorEstabelecimento }}</h2>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
    >
      <template v-slot:items="{ item, index }">
        <td class="td-padding-left">{{ index + 1 }}</td>
        <td class="td-padding-left">
          <a 
            class="link-loja" 
            @click="detalhar(item)"
          >{{ item.nome_loja }}</a>
          <v-btn 
            flat 
            icon 
            color="primary"
            v-clipboard="item.nome_loja"
          >
            <v-icon>content_copy</v-icon>
          </v-btn>
        </td>
        <td class="td-padding-left">{{ formatData(item.created_at) }}</td>
        <td class="td-padding-left">{{ formatCidade(item.cidade) }}</td>
        <td class="td-padding-left">
          <v-icon v-if="item.status_pagamento === -1" color="gray">help_outline</v-icon>
          <v-icon v-else-if="item.status_pagamento === 0" color="green">check_circle</v-icon>
          <v-icon v-else-if="item.status_pagamento === 1" color="yellow darken-3">info</v-icon>
          <v-icon v-else-if="item.status_pagamento === 2" color="red">remove_circle</v-icon>
          <v-icon v-else-if="item.status_pagamento === 3" color="red">highlight_off</v-icon>
        </td>
        <td class="td-padding-left">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon 
                v-on="on"
                :color="colorLojaAberta(item)"
              >
                {{ iconLojaAberta(item) }}
              </v-icon>
            </template>
            <span>{{ tooltipLojaAberta(item) }}</span>
          </v-tooltip>
        </td>
        <td class="td-padding-left">
          <v-chip 
            v-if="item.ultimo_acesso_app === null" 
            color="red" 
            text-color="white">Inativo</v-chip>
          <v-chip 
            v-else-if="acessoRecente(item.ultimo_acesso_app)"
            color="green"
            text-color="white">Online</v-chip>
          <template v-else>{{ formatData(item.ultimo_acesso_app) }}</template>
        </td>
        <td class="td-padding-left">{{ formatTexto(item.versao_app) }}</td>
        <td class="td-padding-left">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon 
                v-on="on"
                :color="corSaudacao(item.saudacao)"
              >
                {{ item.saudacao === 4 ? 'alarm' : 'email' }}
              </v-icon>
            </template>
            <span>{{ tooltipSaudacao(item) }}</span>
          </v-tooltip>
        </td>
        <td class="td-padding-left">{{ formatData(item.ultimo_pedido) }}</td>
        <td 
          :class="{'abaixo-media': abaixoMedia(item.quantidade_pedidos_ok)}"
          class="td-padding-left">{{ item.quantidade_pedidos_ok }}</td>
        <td class="td-padding-left">{{ formatValor(item.ticket_medio) }}</td>
        <td class="td-padding-left">{{ formatValor(item.valor_bruto) }}</td>
        <td class="td-padding-left">{{ formatValor(item.taxa_delivery) }}</td>
        <td class="td-padding-left td-padding-right">{{ formatValor(item.valor_liquido) }}</td>
      </template>
      <template v-slot:no-data>
        <h1>Nenhum estabelecimento encontrado</h1>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDate } from '../utils/data'

export default {
  name: 'EstabelecimentosTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    quantidadeCategorias: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: '#',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Nome',
          value: 'nome_loja',
          align: 'left'
        },
        {
          text: 'Criação',
          value: 'created_at'
        },
        {
          text: 'Cidade',
          value: 'cidade.nome'
        },
        {
          text: 'Pag.',
          value: 'status_pagamento'
        },
        {
          text: 'Ab.',
          value: 'aberto'
        },
        {
          text: 'Ult. acesso',
          value: 'ultimo_acesso_app'
        },
        {
          text: 'App',
          value: 'versao_app'
        },
        {
          text: 'Saud.',
          value: 'saudacao'
        },
        {
          text: 'Ult. Pedido',
          value: 'ultimo_pedido'
        },
        {
          text: 'Qtd',
          value: 'quantidade_pedidos_ok'
        },
        {
          text: 'Tk Méd',
          value: 'ticket_medio'
        },
        {
          text: 'Valor Brt',
          value: 'valor_bruto'
        },
        {
          text: 'Tx deliv',
          value: 'taxa_delivery'
        },
        {
          text: 'Valor Liq',
          value: 'valor_liquido'
        },
      ],
      quantidadeEstabelecimentos: 0,
      quantidadeEstabelecimentosComPedido: 0,
      quantidadePedidos: 0,
      valorBruto: 0,
      taxaEntregaPedidos: 0,
      valorLiquido: 0,
      ticketMedio: 0,
      mediaPedidosPorEstabelecimento: 0
    }
  },
  watch: {
    items() {
      let quantidadeEstabelecimentos = this.items.length
      let quantidadeEstabelecimentosComPedido = 0
      let quantidadePedidos = 0
      let valorBruto = 0
      let taxaEntregaPedidos = 0
      let valorLiquido = 0
      for (let i = 0; i < quantidadeEstabelecimentos; i ++) {
        const e = this.items[i]
        quantidadePedidos += e.quantidade_pedidos_ok
        if (e.quantidade_pedidos_ok > 0) {
          quantidadeEstabelecimentosComPedido ++
        }
        valorBruto += e.valor_bruto
        taxaEntregaPedidos += e.taxa_delivery
        valorLiquido += e.valor_liquido
      }
      this.quantidadeEstabelecimentos = quantidadeEstabelecimentos
      this.quantidadeEstabelecimentosComPedido = quantidadeEstabelecimentosComPedido
      this.quantidadePedidos = quantidadePedidos
      this.valorBruto = valorBruto
      this.taxaEntregaPedidos = taxaEntregaPedidos
      this.valorLiquido = valorLiquido
      this.ticketMedio = quantidadePedidos > 0 ? valorLiquido / quantidadePedidos : 0
      this.mediaPedidosPorEstabelecimento = quantidadeEstabelecimentosComPedido > 0 ? Math.floor(quantidadePedidos / quantidadeEstabelecimentosComPedido) : 0
    }
  },
  methods: {
    calcularTotal(campo) {
      let valor = 0
      for (let i = 0; i < this.items.length; i++) {
        valor += this.items[i][campo]
      }
      return valor
    },
    calcularValor(campo) {
      return this.calcularTotal(campo).toFixed(2)
    },
    formatData(value) {
      return formatDate(value)
    },
    detalhar(estabelecimento) {
      this.$emit('detalhar', estabelecimento)
    },
    acessoRecente(value) {
      const data = new Date(value)
      const now = new Date()
      return data > new Date(now.getTime() - 5 * 60 * 1000)
    },
    formatTexto(value) {
      if (value === null) {
        return '---'
      }
      return value
    },
    formatCidade(value) {
      if (value === null) {
        return '---'
      }
      return `${value.nome}/${value.estado}`
    },
    corSaudacao(value) {
      switch (value) {
        case 3:
          return 'green'
        case 2:
          return 'blue'
        case 1:
          return 'orange'
        case 0:
          return 'red'
        case -1:
        case 4:
          return 'gray darken-3'
      }
    },
    formatValor(value) {
      let d = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      d = d.replace('R$', '').trim()
      return d
    },
    abaixoMedia(quantidade) {
      return (quantidade < this.mediaPedidosPorEstabelecimento) && (this.quantidadeCategorias === 1)
    },
    tooltipSaudacao(item) {
      switch (item.saudacao) {
        case -1:
          return 'Desabilitado (Painel Gerencial)'
        case 0:
          return 'Sem permissão (Android) e App Lojista' // Desconfigurado | Sem permissão
        case 1:
          return 'Sem permissão no App Lojista' // Desconfigurado | Permissão OK
        case 2:
          return 'Sem permissão (Android)' // Configurado | Sem permissão
        case 3:
          return 'Habilitado' // Configurado | Permissão OK
        case 4:
          return 'Sem acesso há 1 Semana'
        default:
          return 'Indefinido'
      }
    },
    iconLojaAberta(loja) {
      if (loja.fechado_temporariamente) {
        return 'lock_clock'
      }
      return (loja.agendamento || loja.acesso_recente_gerente) ? 'lock_open' : 'lock'
    },
    colorLojaAberta(loja) {
      if (!loja.fechado_temporariamente) {
        if (loja.agendamento || (loja.aberto && loja.acesso_recente_gerente)) {
          return 'green'
        }
        if (!loja.aberto && loja.acesso_recente_gerente) {
          return 'orange'
        }
        if (loja.aberto && !loja.acesso_recente_gerente) {
          return 'red'
        }
      }
      return 'gray darken-3' 
    },
    tooltipLojaAberta(loja) {
      if (loja.fechado_temporariamente) {
        return 'Fechado temporariamente'
      }
      if (loja.agendamento || (loja.aberto && loja.acesso_recente_gerente)) {
        let retorno = 'Aberto'
        if (loja.agendamento) {
          retorno += ' | Agendamentos'
        }
        return retorno
      }
      if (!loja.aberto && loja.acesso_recente_gerente) {
        return 'Aberto fora do horário de funcionamento'
      }
      if (loja.aberto && !loja.acesso_recente_gerente) {
        return 'Fechado no horário de funcionamento'
      }
      return 'Fechado'
    }
  }
}
</script>

<style scoped>
.td-padding-left {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 5px;
}

.td-padding-right {
  padding-right: 5px;
}

.link-loja {
  color: black;
}

.link-loja:hover {
  color: #1976d2;
}

.abaixo-media {
  color: red;
}
</style>
